// import {Get, Post} from "@paraview/lib";
import { Get, Post } from "para-lib";
import { PORTAL_API, PORTAL_CTX, ESC_SSO, ESC_IDM } from "../../config/portal.config";
import API_CONFIG from "../../config/api.config";

const CTX = { ctx: PORTAL_CTX };

/** 定义一个泛型 **/
interface T {
    [name: string]: any;
}

// 生成校验图片
export const newVerifyImage = (userName: string) => {
    return Post({
        url: PORTAL_API.newVerifyImage,
        data: {
            userName
        },
        ...CTX
    });
};

// 校验图片
export const checkVerifyImage = (data: T) => {
    return Post({
        url: PORTAL_API.checkVerifyImage,
        data,
        ...CTX
    });
};


// 校验用户  拿到找回方式
export const checkExistUserName = (data: T) => {
    return Post({
        url: API_CONFIG.resetTypeByCode,
        data,
        ...CTX
    });
};


// 发送验证码
export const sendVerificationCode = (data: T) => {
    return Post({
        url: PORTAL_API.sendVerificationCode,
        glabal: true,
        data,
        ...CTX
    });
};


// 校验密码
export const verifyPwd = (data: T) => {
    return Post({
        url: PORTAL_API.verifyPwd,
        data,
        glabal: true,
        ...CTX
    });
};


// 校验sso 传递过来的用户
export const verifyUser = (data: T) => {
    return Post({
        url: PORTAL_API.verifyUser,
        data,
        ...CTX
    });
};

// 重置密码
export const updatePwd = (data: T) => {
    return Post({
        url: PORTAL_API.updatePwd,
        glabal: true,
        data,
        ...CTX
    });
};

// 生成二维码
export const generateQrcode = (nonce: number, username: string) => {
    return Post({
        url: PORTAL_API.generateQrcode,
        ctx: ESC_SSO,
        responseType: "arraybuffer",
        data: {
            nonce,
            type: "resetPassword",
            username
        }
    });
};


// 长轮询接口  不需要报错提示
export const pollingResult = (loginTicket: number) => {
    return Get({
        url: PORTAL_API.pollingResult,
        ctx: ESC_SSO,
        glabal: true,
        params: {
            loginTicket
        }
    });
};

export const getLocalFn = () => {
    return Get({
        url: PORTAL_API.localSetting,
        ctx: ESC_SSO
    });
};

export const queryAllValid = () => {
    return Get({
        url: PORTAL_API.queryAllValid,
        ctx: ESC_SSO
    });
};

/**
* 获取公钥
*/
export const getPublicKey = () => {
    return Get({
        url: PORTAL_API.getPublicKey,
        ctx: ESC_IDM,
    })
}
